module.exports = __webpack_public_path__ + "static/media/ico_icici_512.854cbc42.png";